import React, { useState, useEffect } from 'react'
import { Button, Col, FlexboxGrid, Icon, List, Panel, Popover, Row, Whisper } from 'rsuite'
import PanalLoadingTemplate from '../loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { cloneDeep } from 'lodash-es'
import DashboradToggle from './DashboradToggle'
import HeaderConfig from './HeaderConfig'
import { getUserOverviewWidget } from '../../redux/actions/dashboard'

export default function UserDashboardWidget({ config, onSettingChange = () => {} }) {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [sort, setSort] = useState('asc')
  const [datas, setDatas] = useState([])

  useEffect(() => {
    if (config) {
      //setSchema(config.schema)
      setSchema(settingSchema)
      setDatas(settingSchema.datas || [])
    } else {
      handelGetSchema()
    }
  }, [])

  const handelGetSchema = async () => {
    setIsLoading(true)
    try {
      const response = await getUserOverviewWidget()
      // let response = mockSchema
      setSchema(response)
      setDatas(response.datas || [])
    } catch (e) {
      console.log(e)
      setError({})
    }
    setIsLoading(false)
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  const styleCenter = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '60px',
  }

  const handelSort = (sort) => {
    var arr = cloneDeep(datas)
    console.log(arr)
    if (sort == 'asc') {
      arr = arr.sort((a, b) => b.projectCode.localeCompare(a.projectCode))
      setSort('desc')
    } else {
      arr = arr.sort((a, b) => a.projectCode.localeCompare(b.projectCode))
      setSort('asc')
    }

    console.log(arr)
    setDatas(arr)
  }

  const Speaker = ({ data, item, ...props }) => {
    return (
      <Popover title="อยู่ในกระบวนการ" {...props}>
        {data?.map((e, index) => {
          if (e.code < item.statusCode) {
            return (
              <p>
                <Icon size="lg" icon="check-circle" style={{ color: '#2DA888' }} /> {e.name}{' '}
                {item.remark || ''}
              </p>
            )
          } else if (e.code == item.statusCode) {
            return (
              <p>
                <Icon size="lg" icon="dot-circle-o" style={{ color: '#eeb189' }} /> {e.name}{' '}
                {item.remark || ''}
              </p>
            )
          } else {
            return (
              <p>
                <Icon size="lg" icon="minus-circle" /> {e.name} {item.remark || ''}
              </p>
            )
          }
        })}
      </Popover>
    )
  }

  return (
    <>
      {config && (
        <DashboradToggle
          onChange={onSettingChange}
          dashboradName={config.key}
          checked={config.show}
          style={{ marginTop: 20, marginBottom: -10 }}
        />
      )}
      <Panel
        // header={<HeaderConfig header={schema.header} config={config} onChange={onSettingChange} />}
        header={schema.header}
        bordered
        shaded
        collapsible
        defaultExpanded
        style={{ marginTop: 10, marginBottom: 10 }}
      >
        <List>
          <List.Item key={'header'} index={-1}>
            <FlexboxGrid>
              <FlexboxGrid.Item colspan={3} style={{ ...styleCenter, justifyContent: 'left' }}>
                <Row style={{ width: '100%', marginLeft: 10 }}>
                  <Col lg={20} md={20} sm={20} xs={20} style={{ textAlign: 'left' }}>
                    โครงการ
                  </Col>
                  <Col lg={4} md={4} sm={4} xs={4} style={{ textAlign: 'right' }}>
                    <Icon
                      size="lg"
                      style={{ textAlign: 'right', cursor: 'pointer' }}
                      icon={sort == 'asc' ? 'chevron-circle-down' : 'chevron-circle-up'}
                      onClick={() => handelSort(sort)}
                    />
                  </Col>
                </Row>
              </FlexboxGrid.Item>
              <FlexboxGrid.Item
                colspan={21}
                style={{
                  ...styleCenter,
                  textAlign: 'center',
                  alignItems: 'center',
                }}
              >
                <Row style={{ width: '100%', marginRight: 10 }}>
                  {schema.statusDatas.map((e, index) => (
                    <Col lg={3} md={3} sm={3} xs={3}>
                      <Button
                        style={{
                          width: '100%',
                          marginLeft: 10,
                          marginRight: 10,
                          backgroundColor: e.stepColor,
                        }}
                      >
                        {e.stepName}
                      </Button>
                    </Col>
                  ))}
                </Row>
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </List.Item>
        </List>
        <List hover style={{ maxHeight: 400 }}>
          {datas?.map((item, index) => (
            <List.Item key={item.projectCode} index={index}>
              <FlexboxGrid>
                <FlexboxGrid.Item colspan={3} style={{ ...styleCenter, justifyContent: 'left' }}>
                  <Row style={{ width: '100%', marginLeft: 10 }}>
                    {item.projectCode}
                    {/* {item.projectName} */}
                  </Row>
                </FlexboxGrid.Item>
                <FlexboxGrid.Item
                  colspan={21}
                  style={{ ...styleCenter, textAlign: 'center', alignItems: 'center' }}
                >
                  <Row style={{ width: '100%', marginRight: 10 }}>
                    {schema.statusDatas.map((e, index) => (
                      <Col lg={3} md={3} sm={3} xs={3}>
                        {item.stepCode > e.stepCode ? (
                          <Button
                            appearance="ghost"
                            style={{
                              width: '100%',
                              marginLeft: 10,
                              marginRight: 10,
                              borderColor: e.stepColor,
                            }}
                          >
                            <Icon size="lg" icon="check-circle" style={{ color: '#2DA888' }} />
                          </Button>
                        ) : (
                          <>
                            {item.stepCode == e.stepCode ? (
                              <Whisper
                                trigger="active"
                                placement={'auto'}
                                speaker={<Speaker data={e.status} item={item} />}
                              >
                                <Button
                                  appearance="ghost"
                                  style={{
                                    width: '100%',
                                    marginLeft: 10,
                                    marginRight: 10,
                                    borderColor: e.stepColor,
                                  }}
                                >
                                  <span style={{ color: '#575757' }}>อยู่ในกระบวนการ...</span>
                                </Button>
                              </Whisper>
                            ) : (
                              <span></span>
                            )}
                          </>
                        )}
                      </Col>
                    ))}
                  </Row>
                </FlexboxGrid.Item>
              </FlexboxGrid>
            </List.Item>
          ))}
        </List>
      </Panel>
    </>
  )
}

const settingSchema = {
  header: 'โครงการของฉัน',
  statusDatas: [
    {
      stepCode: 1,
      stepName: 'ร่างข้อเสนอ',
      stepColor: '#ffe0aa',
      status: [
        {
          code: 1,
          name: 'ร่างข้อเสนอโครงการ',
          color: '',
        },
      ],
    },
    {
      stepCode: 2,
      stepName: 'คัดกรอง',
      stepColor: '#fdcd9d',
      status: [
        {
          code: 1,
          name: 'คัดกรอง',
          color: '',
        },
        {
          code: 2,
          name: 'ส่งกลับภาคีแก้ไข',
          color: '',
        },
      ],
    },
    {
      stepCode: 3,
      stepName: 'กลั่นกรอง',
      stepColor: '#52b7ae',
      status: [
        {
          code: 1,
          name: 'กลั่นกรอง',
          color: '',
        },
        {
          code: 2,
          name: 'ส่งกลับให้ผู้รับทุนแก้ไข',
          color: '',
        },
      ],
    },
    {
      stepCode: 4,
      stepName: 'พิจารณาอนุมัติ',
      stepColor: '#32cabd',
      status: [
        {
          code: 1,
          name: 'สำนักจัดทำเอกสารประกอบการอนุมัติ',
          color: '',
        },
        {
          code: 2,
          name: 'ผู้มีอำนาจพิจารณา',
          color: '',
        },
      ],
    },
    {
      stepCode: 5,
      stepName: 'ทำสัญญา',
      stepColor: '#86d9e0',
      status: [
        {
          code: 1,
          name: 'ทำสัญญา',
          color: '',
        },
        {
          code: 2,
          name: 'ขอเอกสารเพิ่มเติม',
          color: '',
        },
        {
          code: 3,
          name: 'ลงนามสัญญา',
          color: '',
        },
        {
          code: 4,
          name: 'ติดอากรและแนบบัญชีโครงการ',
          color: '',
        },
      ],
    },
    {
      stepCode: 6,
      stepName: 'เบิกเงินโครงการ',
      stepColor: '#FFA3AE',
      status: [
        {
          code: 1,
          name: 'สำนักพิจารณาเอกสารขอเบิกเงิน',
          color: '',
        },
        {
          code: 2,
          name: 'ผู้มีอำนาจพิจารณาคำขอเบิกเงิน',
          color: '',
        },
      ],
    },
    {
      stepCode: 7,
      stepName: 'จ่ายเงินโครงการ',
      stepColor: '#f4d8da',
      status: [
        {
          code: 1,
          name: 'ฝ่ายบัญชีและการเงินตรวจเอกสารประกอบการเบิกเงิน',
          color: '',
        },
        {
          code: 2,
          name: 'ธนาคารโอนเงิน',
          color: '',
        },
      ],
    },
    {
      stepCode: 8,
      stepName: 'ขอปิด/ยุติ โครงการ',
      stepColor: '#e44d63',
      status: [
        {
          code: 1,
          name: 'สรุปผลการดำเนินโครงการ',
          color: '',
        },
        {
          code: 2,
          name: 'สำนักพิจารณาเอกสารขอปิดโครงการ',
          color: '',
        },
        {
          code: 3,
          name: 'สำนักจัดทำเอกสารประกอบเพื่อขอปิด/ยุติโครงการ',
          color: '',
        },
        {
          code: 4,
          name: 'ฝ่ายบัญชีและการเงินตรวจสอบ เอกสารประกอบการปิด/ยุติโครงการ',
          color: '',
        },
        {
          code: 5,
          name: 'ปิดโครงการและจัดเก็บเอกสาร',
          color: '',
        },
      ],
    },
  ],
  datas: [
    {
      projectCode: 'XX-XXXXXX',
      projectName: 'โครงการ XXXXXXX',
      stepCode: 5,
      statusCode: 1,
      statusName: 'กลั่นกรอง',
    },
  ],
}

const mockSchema = {
  header: 'โครงการของฉัน',
  statusDatas: [
    {
      stepCode: 1,
      stepName: 'ร่างข้อเสนอ',
      stepColor: '#ffe0aa',
      status: [
        {
          code: 1,
          name: 'ร่างข้อเสนอโครงการ',
          color: '',
        },
      ],
    },
    {
      stepCode: 2,
      stepName: 'คัดกรอง',
      stepColor: '#fdcd9d',
      status: [
        {
          code: 1,
          name: 'คัดกรอง',
          color: '',
        },
        {
          code: 2,
          name: 'ส่งกลับภาคีแก้ไข',
          color: '',
        },
      ],
    },
    {
      stepCode: 3,
      stepName: 'กลั่นกรอง',
      stepColor: '#52b7ae',
      status: [
        {
          code: 1,
          name: 'กลั่นกรอง',
          color: '',
        },
        {
          code: 2,
          name: 'ส่งกลับให้ผู้รับทุนแก้ไข',
          color: '',
        },
      ],
    },
    {
      stepCode: 4,
      stepName: 'พิจารณาอนุมัติ',
      stepColor: '#32cabd',
      status: [
        {
          code: 1,
          name: 'สำนักจัดทำเอกสารประกอบการอนุมัติ',
          color: '',
        },
        {
          code: 2,
          name: 'ผู้มีอำนาจพิจารณา',
          color: '',
        },
      ],
    },
    {
      stepCode: 5,
      stepName: 'ทำสัญญา',
      stepColor: '#86d9e0',
      status: [
        {
          code: 1,
          name: 'ทำสัญญา',
          color: '',
        },
        {
          code: 2,
          name: 'ขอเอกสารเพิ่มเติม',
          color: '',
        },
        {
          code: 3,
          name: 'ลงนามสัญญา',
          color: '',
        },
        {
          code: 4,
          name: 'ติดอากรและแนบบัญชีโครงการ',
          color: '',
        },
      ],
    },
    {
      stepCode: 6,
      stepName: 'เบิกเงินโครงการ',
      stepColor: '#FFA3AE',
      status: [
        {
          code: 1,
          name: 'สำนักพิจารณาเอกสารขอเบิกเงิน',
          color: '',
        },
        {
          code: 2,
          name: 'ผู้มีอำนาจพิจารณาคำขอเบิกเงิน',
          color: '',
        },
      ],
    },
    {
      stepCode: 7,
      stepName: 'จ่ายเงินโครงการ',
      stepColor: '#f4d8da',
      status: [
        {
          code: 1,
          name: 'ฝ่ายบัญชีและการเงินตรวจเอกสารประกอบการเบิกเงิน',
          color: '',
        },
        {
          code: 2,
          name: 'ธนาคารโอนเงิน',
          color: '',
        },
      ],
    },
    {
      stepCode: 8,
      stepName: 'ขอปิด/ยุติ โครงการ',
      stepColor: '#e44d63',
      status: [
        {
          code: 1,
          name: 'สรุปผลการดำเนินโครงการ',
          color: '',
        },
        {
          code: 2,
          name: 'สำนักพิจารณาเอกสารขอปิดโครงการ',
          color: '',
        },
        {
          code: 3,
          name: 'สำนักจัดทำเอกสารประกอบเพื่อขอปิด/ยุติโครงการ',
          color: '',
        },
        {
          code: 4,
          name: 'ฝ่ายบัญชีและการเงินตรวจสอบ เอกสารประกอบการปิด/ยุติโครงการ',
          color: '',
        },
        {
          code: 5,
          name: 'ปิดโครงการและจัดเก็บเอกสาร',
          color: '',
        },
      ],
    },
  ],
  datas: [
    {
      projectCode: '66-00001',
      projectName: 'ไม้ร่ม เปลี่ยนที่ว่างให้เป็นผืนป่า',
      stepCode: 3,
      statusCode: 1,
      statusName: 'กลั่นกรอง',
    },
    {
      projectCode: '66-00002',
      projectName: 'ลดพฤติกรรมเสี่ยงลดโรคเรื้อรังโดยใช้ชุมชนเป็นฐาน',
      stepCode: 5,
      statusCode: 2,
      statusName: 'ขอเอกสารเพิ่มเติม',
    },
    {
      projectCode: '66-00003',
      projectName: 'มหาวิทยาลัยสุขภาวะดีแห่งอนาคต',
      stepCode: 8,
      statusCode: 3,
      statusName: 'สำนักจัดทำเอกสารประกอบเพื่อขอปิด/ยุติโครงการ',
    },
  ],
}
